<template>
	<div class="page" data-name="edit-student">	
		<div class="page-content">
			<f7-navbar>
				<f7-nav-left>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
				</f7-nav-left>
				<div class="title">
					회원정보 수정
				</div>
				<f7-nav-right>
					<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
				</f7-nav-right>
    	</f7-navbar>

			<div class="block-title">*필수 정보</div>
			<div class="list no-hairlines">
				<ul>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label ">이름 입력</div>
							<div class="item-input-wrap ">
								<input type="text" name="userName" id="userName" ref="userName">
								<span class="input-clear-button"></span>
							</div>
						
						</div>
    			</li>																	
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">패스워드 입력</div>
							<div class="item-input-wrap">
								<input type="password" name="userPw" ref="userPw">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">입력한 비밀번호확인</div>
							<div class="item-input-wrap">
								<input type="password" name="userPwConfirm" ref="userPwConfirm">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">비밀번호 질문 선택</div>							
							<div class="item-input-wrap input-dropdown-wrap">
								<select name="pwQuestion" ref="pwQuestion">
									<option value="">선택</option>
									<option value="a">출신초등학교는?</option>
									<option value="b">어머님성함은?</option>
									<option value="c">가장친한친구이름은?</option>
									<option value="d">태어난곳은?</option>
								</select>
							</div>
						</div>
					</li>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">답변 입력</div>
							<div class="item-input-wrap">
								<input type="text" name="pwAnswer" ref="pwAnswer">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">생년월일 입력</div>
							<div class="item-input-wrap">
								<input type="date" name="birthDate" ref="birthDate">
								<span class="input-clear-button"></span>
							</div>
						</div>
    			</li>
					<li class="item-content item-input item-input-outline">      
						<div class="item-inner">
							<div class="item-title item-floating-label">학년 선택</div>							
							<div class="item-input-wrap input-dropdown-wrap">
								<select name="userGrade" ref="userGrade">
									<option value="">선택</option>
									<option value="e1">초1</option>																																													
									<option value="e2">초2</option>																					
									<option value="e3">초3</option>
									<option value="e4">초4</option>																					
									<option value="e5">초5</option>						
									<option value="e6">초6</option>											
									<option value="m1">중1</option>						
									<option value="m2">중2</option>						
									<option value="m3">중3</option>						
									<option value="h1">고1</option>						
									<option value="h2">고2</option>						
									<option value="h3">고3</option>
								</select>
							</div>
						</div>
					</li>								
				</ul>
			</div>

			<div class="block-title" style="padding-top:40px">*부가 정보</div>
			<div class="list no-hairlines">
				<ul>
						<li class="item-content item-input item-input-outline row">      
							<div class="col-60">
								<div class="item-inner">								
									<div class="item-input-wrap">
										<input type="text" name="post" ref="postNo" readonly placeholder="우편번호">									
									</div>
								</div>
							</div>
							<div class="col-40">
								<div class="item-inner">				
									<button class="button button-outline"  v-on:click="openPostPopup">검색</button>					
								</div>
							</div>
						</li>
						<li class="item-content item-input item-input-outline" ref="postAddr" style="display:none">
							
							<div class="row">
								<div class="left"></div>
								<div class="right" style="padding-right:5px;"><button class="button" style="padding-top:5px" v-on:click="closePostPopup"><i class="f7-icons">clear</i></button></div>	
							</div>
							<div class="item-inner">							
								<div class="item-input-wrap">			  					
									<div id='postcode' ref="postCode" style="width:'100%';height:'500px'" />       					
								</div>
							</div>
						</li>  
						<li class="item-content item-input item-input-outline">      
							<div class="item-inner">							
								<div class="item-input-wrap">
									<input type="text" name="address" ref="address" readonly placeholder="주소">								
								</div>
							</div>
						</li>
						<li class="item-content item-input item-input-outline">      
							<div class="item-inner">
								<div class="item-title item-floating-label">상세주소</div>
								<div class="item-input-wrap">
									<input type="text" name="subAddress" ref="subAddress">
									<span class="input-clear-button"></span>
								</div>
							</div>
						</li>
						<li class="item-content item-input item-input-outline row">      
							<div class="col-60">
								<div class="item-inner">
									<div class="item-title item-floating-label">휴대폰번호 입력</div>
									<div class="item-input-wrap">
										<input type="tel" name="mobile" ref="mobile" v-on:keyup="keyPress($event,'MOBILE')"  :maxlength="phoneMax">
										<span class="input-clear-button"></span>
									</div>
								</div>
							</div>
							<div class="col-40">
								<label class="item-checkbox item-content">
									<input type="checkbox"  name="sms_receive" id="sms_receive" ref="smsReceive" value="receive" />
									<i class="icon icon-checkbox"></i>
									<div class="item-inner">
										<div class="item-title">수신동의</div>
									</div>
								</label>
							</div>
						</li>
						
						<li class="item-content item-input item-input-outline row">      
							<div class="col-60">
								<div class="item-inner">
									<div class="item-title item-floating-label">EMAIL을 입력</div>
									<div class="item-input-wrap">
										<input type="email" name="email" ref="email">
										<span class="input-clear-button"></span>
									</div>
								</div>
							</div>
							<div class="col-40">
								<label class="item-checkbox item-content">
									<input type="checkbox"  name="email_receive" ref="emailReceive" value="receive" />
									<i class="icon icon-checkbox"></i>
									<div class="item-inner">
										<div class="item-title">수신동의</div>
									</div>
								</label>
							</div>
						</li>
						
						<li class="item-content item-input item-input-outline">      
							<div class="item-inner">
								<div class="item-title item-floating-label">성별 선택</div>							
								<div class="item-input-wrap input-dropdown-wrap">
									<select name="sex" ref="sex">
										<option value="">선택</option>
										<option value="M">남자</option>
										<option value="W">여자</option>
									</select>
								</div>
							</div>
						</li>
						<li class="item-content item-input item-input-outline">      
							<div class="item-inner">
								<div class="item-title item-floating-label">부모님 이름 입력</div>
								<div class="item-input-wrap">
									<input type="text" name="parentName" ref="parentName">
									<span class="input-clear-button"></span>
								</div>
							</div>
						</li>
						<li class="item-content item-input item-input-outline row">      
							<div class="col-60">
								<div class="item-inner">
									<div class="item-title item-floating-label">부모님 휴대폰번호 입력</div>
									<div class="item-input-wrap">
										<input type="tel" name="parentMobile" ref="parentMobile" v-on:keyup="keyPress($event,'MOBILE')" :maxlength="phoneMax">
										<span class="input-clear-button"></span>
									</div>
								</div>
							</div>
							<div class="col-40">
								<label class="item-checkbox item-content">
									<input type="checkbox"  name="parent_sms_receive" ref="parentSmsReceive" value="receive" />
									<i class="icon icon-checkbox"></i>
									<div class="item-inner">
										<div class="item-title">수신동의</div>
									</div>
								</label>
							</div>
						</li>							
						<li class="item-content item-input item-input-outline">
							<div class="item-inner">				
								<button class="button button-fill " ref="edit" v-on:click="editUser">정보수정</button>				
							</div>
						</li>	
				</ul>   
			</div>			

		</div>
	</div>
</template>

<script>

import MODULE from '../../../js/common/module.js';
import Vue from 'vue';
import { f7 } from 'framework7-vue';
import CONST from '../../../js/common/constant.js';
import AUTH from '../../../js/common/auth.js';
import PAGES from '../../../js/pages.js';
import API from '../../../js/common/api.js';

export default {
	data() {
		return {			
			passWord:"",
			phoneMax: 13,				
    };
	},
	mounted() {	
		const _this = this;		
		_this.passWord = _this.$f7route.params.passWord;
		_this.getUserInfo();
	},
	methods: {
		getUserInfo(){
			const _this = this;
			
			var userInfo = AUTH.getUserInfo();			
			
			let param = {			
			}

			API.ajaxRequest({								
				url: API.getUserInfo(),
				data:param
			}).then(function (data){
				_this.setUserInfo(data);
			}).catch(function (code){
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});
			
		},
		setUserInfo(userInfo){
			const _this = this;
			_this.setElement(_this.$refs.userName, userInfo.USER_NAME);
			_this.setElement(_this.$refs.userPw, _this.passWord);
			_this.setElement(_this.$refs.pwQuestion, userInfo.PW_QUESTION);
			_this.setElement(_this.$refs.pwAnswer, userInfo.PW_ANSWER);

			var formatDate = moment(userInfo.BIRTH_DATE).format("YYYY-MM-DD");	
			_this.setElement(_this.$refs.birthDate, formatDate);
			_this.setElement(_this.$refs.userGrade, userInfo.USERGRADE_ID);
			var address = userInfo.ADDRESS.split(".");
			_this.setElement(_this.$refs.postNo, address[0]);
			_this.setElement(_this.$refs.address, address[1]);
			_this.setElement(_this.$refs.subAddress, address[2]);
			_this.setElement(_this.$refs.mobile, userInfo.MOBILE);
			
			if(userInfo.SMS_RECEIVE == "receive"){
				$(_this.$refs.smsReceive).prop('checked', true);		
			}

			_this.setElement(_this.$refs.email, userInfo.EMAIL);

			if(userInfo.EMAIL_RECEIVE == "receive"){
				$(_this.$refs.emailReceive).prop('checked', true);		
			}

			_this.setElement(_this.$refs.sex, userInfo.SEX);
			_this.setElement(_this.$refs.parentName, userInfo.PARENT_NAME);

			_this.setElement(_this.$refs.parentMobile, userInfo.PARENT_MOBILE);
			
			if(userInfo.PARENT_SMS_RECEIVE == "receive"){
				$(_this.$refs.parentSmsReceive).prop('checked', true);		
			}

		},
		setElement(element,value){
			var el = $(element);
			el.val(value);
			el.addClass("input-with-value");
			el.parents("li").addClass("item-input-with-value");
		},
		postCodeMount(){			
			const _this = this;
			const scriptId = 'daum_postcode_script';
			const isExist = !!document.getElementById(scriptId);
		
			if (!isExist) {
				const script = document.createElement('script');
				script.src = "https://ssl.daumcdn.net/dmaps/map_js_init/postcode.v2.js?autoload=false";
				script.onload = () => _this.postCodeInitiate(this);
				script.onerror = error => _this.handleError(error);
				script.id = scriptId;
				document.body.appendChild(script);
			} else {
				_this.postCodeInitiate(this);
			} 
			
		},
		postCodeInitiate(){		
			const _this = this;
			window.daum.postcode.load(() => {
				new window.daum.Postcode({
					oncomplete: function oncomplete (data) {
						if (data.postcode1) {
							_this.$refs.postNo.value = data.postcode;
						}else{
							_this.$refs.postNo.value = data.zonecode;
						}
						if (data.userSelectedType == "R") {
							_this.$refs.address.value = data.roadAddress;							
						}else{
							_this.$refs.address.value = data.jibunAddress;							
						}
						
						_this.$refs.postAddr.style.display="none";
					},
					onresize: function onresize (size) {              
					},          
					autoMapping: false,
					autoResize: true,
					hideEngBtn: false,
					hideMapBtn: false,						
					width: '100%',
					height: '400px'
				}).embed(_this.$refs.postCode, { q: null, autoClose: true })
			});
		},
		handleError(error){
			//
		},
		keyPress(event,type){
			const _this = this;

			if(type == "MOBILE"){
				const element = event.currentTarget;					
				element.value = MODULE.Util.autoHypenMobile(element.value);
			}
		},
		openPostPopup(event){
			const _this = this;
			_this.$refs.postAddr.style.display="block";
			_this.postCodeMount();
		},
		closePostPopup(event){
			const _this = this;
			_this.$refs.postAddr.style.display="none";
		},
		editUser(event){
			const _this = this;						

			var userName = _this.$refs.userName.value;
			if(MODULE.Util.isEmpty(userName)){
				MODULE.DialogBox.warnToast("이름을 입력하셔야 합니다.");
				return false;	
			}

			var userPw = _this.$refs.userPw.value;
			if(MODULE.Util.isEmpty(userPw)){
				MODULE.DialogBox.warnToast("패스워드를 입력하세요.");
				return false;
			}

			if(MODULE.Util.checkPassWordReg(userPw) < 2){
				MODULE.DialogBox.warnToast("비밀번호는 영어 대문자, 영어 소문자, 숫자, 특수문자 중 2종류 이상으로 구성해야합니다.");				
				return false;
			}

			if(userPw != _this.$refs.userPwConfirm.value){
				MODULE.DialogBox.warnToast("입력한 패스워드가 틀립니다.");
				return false;
			}

			var pwQuestion = _this.$refs.pwQuestion.value; 
			if(MODULE.Util.isEmpty(pwQuestion)){
				MODULE.DialogBox.warnToast("비밀번호 질문을 선택 하셔야 합니다.");
				return false;
			}

			var pwAnswer = _this.$refs.pwAnswer.value;
			if(MODULE.Util.isEmpty(pwAnswer)){
				MODULE.DialogBox.warnToast("비밀번호 질문에 대한 답변을 입력하셔야 합니다.");
				return false;
			}

			var birthDate = _this.$refs.birthDate.value;
			if(MODULE.Util.isEmpty(birthDate)){
				MODULE.DialogBox.warnToast("생년월일을 입력하세요.");
				return false;
			}

			var userGrade = _this.$refs.userGrade.value;
			if(MODULE.Util.isEmpty(userGrade)){
				MODULE.DialogBox.warnToast("학년을 선택 하셔야 합니다.");
				return false;
			}
			
			var mobile = _this.$refs.mobile.value;
			if(MODULE.Util.isNotEmpty(mobile)){

				if(!MODULE.Util.isValidMobile(mobile)){
					MODULE.DialogBox.warnToast("휴대폰번호가 올바르지 않습니다.");
					return false;
				}
			}

			var email = _this.$refs.email.value;
			if(MODULE.Util.isNotEmpty(email)){

				if(!MODULE.Util.isValidEmail(email)){
					MODULE.DialogBox.warnToast("올바르지 않은 이메일 형식입니다.");
					return false;
				}					
			}
  
			var parentMobile = _this.$refs.parentMobile.value;				
			if(MODULE.Util.isNotEmpty(parentMobile)){

				if(!MODULE.Util.isValidMobile(parentMobile)){
					MODULE.DialogBox.warnToast("부모님 휴대폰번호가 올바르지 않습니다.");
					return false;
				}
			}
				
			var address = _this.$refs.postNo.value + "." + _this.$refs.address.value + "." + _this.$refs.subAddress.value;

			var smsReceive = "";
			if (_this.$refs.smsReceive.checked) {
				smsReceive = _this.$refs.smsReceive.value;
			}								

			var parentName = _this.$refs.parentName.value;
			var parentSmsReceive = "";
			if (_this.$refs.parentSmsReceive.checked) {
				parentSmsReceive = _this.$refs.parentSmsReceive.value;
			}				

			var emailReceive = "";
			if (_this.$refs.emailReceive.checked) {
				emailReceive = _this.$refs.emailReceive.value;
			}	
			
			var sex = _this.$refs.sex.value;
	
			let requestInfo = {
				userName         : userName,		
				userPw 	 	       : userPw,
				pwQuestion       : pwQuestion,
				pwAnswer 	       : pwAnswer,					
				birthDate        : birthDate,
				userGrade        : userGrade,				
				address 	       : address,
				mobile		       : mobile,
				smsReceive       : smsReceive,
				email            : email,
				parentName 	     : parentName,
				parentMobile     : parentMobile,
				parentSmsReceive : parentSmsReceive,
				userType 			 	 : "student",
				sex              : sex, 
				emailReceive     : emailReceive
			}
														
					
			API.jsonRequest({ //resultValue.accessToken 이 null 생기는 이유 ??  
		//	MODULE.JsonRequest.request({
				url : API.editUser(),
				data : requestInfo
				//data : JSON.stringify(requestInfo)	
			}).then(function (data){							
				
				MODULE.DialogBox.message("정보가 수정되었습니다.");
		
			}).catch(function(code){						
				if(code == CONST.resultCode.FAIL){
					MODULE.DialogBox.message("정보수정에 실패 하였습니다.");
				}else{
					if (code == CONST.resultCode.EMPTY) {
						MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다.<br/>코드를 확인하세요.");
					}
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				}
				
			});
		}
	}
}
</script>

